import DisclaimerBox from './DisclaimerBox';
export default DisclaimerBox;
